import { Flex, Text } from "@chakra-ui/react";
import { Accordion, Checkbox, RangeSlider, TripTile } from "components";
import { TRIP_TILE } from "data";
import { ChangeEvent, useState } from "react";

const FlightDetailsTab = () => {
    const [flightVersion, setFlightVersion] = useState('best');
    const onVersionChanged = (version: string) => setFlightVersion(version);

  return (
    <Flex marginTop={10} height='1000px'>
        <Flex flexDirection='column' width="300px" height='500px' justifyContent='space-between'>
            <Flex justifyContent='space-between' backgroundColor='#F9F9F9' borderRadius='25px' align='center' padding={2} >
                <Text fontWeight={500} fontSize="26px">Filters</Text>
                <Text cursor='pointer' color='#A3A3A3' fontWeight={600} fontSize='14px'>Clear</Text>
            </Flex>
            <Accordion label="Connections">
                <Flex flexDirection='column'>
                    <Checkbox size="lg" label="Direct" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="1 Stop" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="2 Stops and more" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                </Flex>
            </Accordion>
            <Accordion label="Times">
                <Flex flexDirection='column'>
                    <Flex flexDirection='column'>
                        <Text fontWeight={400} fontSize='15px'>Departure from London</Text>
                        <RangeSlider labelStart="Thu 00:00" labelEnd="23:00" defaultvalues={[0,100]} onChange={function (value: number[]): void {
                            throw new Error("Function not implemented.");
                        } } />
                      </Flex>
                      <Flex flexDirection='column'>
                        <Text fontWeight={400} fontSize='15px'>Arrival at Dubai</Text>
                        <RangeSlider labelStart="Sun 00:00" labelEnd="23:00" defaultvalues={[0,100]} onChange={function (value: number[]): void {
                            throw new Error("Function not implemented.");
                        } } />
                      </Flex>
                      <Flex flexDirection='column'>
                        <Text fontWeight={400} fontSize='15px'>Journey Duration</Text>
                        <RangeSlider labelStart="6h 20m" labelEnd="18h 49m" defaultvalues={[0,100]} onChange={function (value: number[]): void {
                            throw new Error("Function not implemented.");
                        } } />
                      </Flex>
                </Flex>
            </Accordion>
            <Accordion label="Airlines">
                <Flex flexDirection='column'>
                    <Checkbox size="lg" label="Emirates" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Etihad Airways" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="KLM" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Lufthansa" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="PIA" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Qatar Airways" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Turkish Airlines" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Saudia" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Airline Combinations" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                </Flex>
            </Accordion>
            <Accordion label="Airports">
                <Flex flexDirection='column'>
                    <Checkbox size="lg" label="London Heathrow (LHR)" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="London City (LCY)" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Gatwick (LGW)" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                     <Checkbox size="lg" label="Dubai International (DXB)" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                        throw new Error("Function not implemented.");
                    } } />
                    <Checkbox size="lg" label="Al Makhtoum (DWC)" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                       throw new Error("Function not implemented.");
                   } } />
                </Flex>     
            </Accordion>
        </Flex>
        <Flex flexDirection='column' marginLeft={20}>
            <Flex marginBottom={10} cursor='pointer'>
                <Flex flexDirection='column' onClick={() => onVersionChanged('best')} padding={10} backgroundColor={flightVersion==='best' ? '#3498FE': '#F9F9F9'} borderTopLeftRadius='20px' borderBottomLeftRadius='20px'>
                    <Text fontWeight={500} fontSize='16px' color={flightVersion === 'best' ? "#FEFEFE": '#000000'}>Best</Text>
                    <Text fontWeight={500} fontSize='26px' color={flightVersion === 'best' ? "#FEFEFE": '#3498FE'}>235 EUR</Text>
                    <Text fontWeight={400} fontSize='12px' color={flightVersion === 'best' ? "#FEFEFE": '#6F6F6F'}>Flight duration: 2h 08 (Average)</Text>
                </Flex>
                <Flex flexDirection='column' onClick={() => onVersionChanged('cheapest')} padding={10} paddingLeft={20} backgroundColor={flightVersion==='cheapest' ? '#3498FE': '#F9F9F9'} >
                    <Text fontWeight={500} fontSize='16px' color={flightVersion === 'cheapest' ? "#FEFEFE": '#000000'}>Cheapest</Text>
                    <Text fontWeight={500} fontSize='26px' color={flightVersion === 'cheapest' ? "#FEFEFE": '#3498FE'}>205 EUR</Text>
                    <Text fontWeight={400} fontSize='12px' color={flightVersion === 'cheapest' ? "#FEFEFE": '#6F6F6F'}>Flight duration: 12h 10 (Average)</Text>
                </Flex>
                <Flex flexDirection='column'  onClick={() => onVersionChanged('fastest')} padding={10} backgroundColor={flightVersion==='fastest' ? '#3498FE': '#F9F9F9'}  borderTopRightRadius='20px' borderBottomRightRadius='20px'>
                    <Text fontWeight={500} fontSize='16px' color={flightVersion === 'fastest' ? "#FEFEFE": '#000000'}>Fastest</Text>
                    <Text fontWeight={500} fontSize='26px' color={flightVersion === 'fastest' ? "#FEFEFE": '#3498FE'}>205 EUR</Text>
                    <Text fontWeight={400} fontSize='12px' color={flightVersion === 'fastest' ? "#FEFEFE": '#6F6F6F'}>Flight duration: 2h 05 (Average)</Text>
                </Flex>
            </Flex>
            <TripTile isFlight data={TRIP_TILE} />
        </Flex>
    </Flex>
  );
};

export { FlightDetailsTab };
